import { WritableObservable } from "micro-observables";

export const shareroomGuideSteps = ["DASHBOARD", "CALENDAR", "LIVE", "WORKSPACES", "ACTIVITY"] as const;

export type ShareroomGuideStep = (typeof shareroomGuideSteps)[number];

export class ShareroomGuidecontroller {
	private _step = new WritableObservable<ShareroomGuideStep>("DASHBOARD");
	readonly step = this._step.readOnly();

	next(): void {
		const step = this.step.get();

		switch (step) {
			case "DASHBOARD":
				this._step.set("CALENDAR");
				break;
			case "CALENDAR":
				this._step.set("LIVE");
				break;
			case "LIVE":
				this._step.set("WORKSPACES");
				break;
			case "WORKSPACES":
				this._step.set("ACTIVITY");
				break;
			default:
				break;
		}
	}

	previous(): void {
		const step = this.step.get();
		switch (step) {
			case "ACTIVITY":
				this._step.set("WORKSPACES");
				break;
			case "WORKSPACES":
				this._step.set("LIVE");
				break;
			case "LIVE":
				this._step.set("CALENDAR");
				break;
			case "CALENDAR":
				this._step.set("DASHBOARD");
				break;
			default:
				break;
		}
	}
}
